import { render, staticRenderFns } from "./McpAdminPanel.vue?vue&type=template&id=eca2ddf0"
import script from "./McpAdminPanel.vue?vue&type=script&lang=js"
export * from "./McpAdminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports